module.exports = __webpack_public_path__ + "img/eifel-tour-01.c259b76f.jpg";